export class loadFont {
  // 字體連結，通常使用google font
  fontList = [
    "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;600;700;900&display=swap",
  ];
  // 一次載入所有字體連結
  allFontLink =
    "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;600;700;900&display=swap";

  loadAllFont() {
    if (!this.checkAllFontLoaded()) {
      this.removeCurrentFontLink();
      let fontLink = document.createElement("link");
      fontLink.href = this.allFontLink;
      fontLink.rel = "stylesheet";
      fontLink.type = "text/css";
      document.head.appendChild(fontLink);
    }
  }

  checkFontLoad() {
    const body_text = this.getBodyText();
    body_text != "" ? this.loadFont(body_text) : "";
  }

  loadFont(text) {
    // 如果已經載入全部字型則跳過
    if (this.checkAllFontLoaded()) {
      return;
    }
    // 如果先前已經有載入過字型，則先移除後載入全部字型
    else if (this.checkIfFontLoaded()) {
      this.loadAllFont();
    } else {
      this.fontList.forEach((font) => {
        const fontLink = document.createElement("link");
        try {
          // 額外過濾特殊字符和 emoji，確保安全編碼
          const safeText = this.sanitizeText(text);
          fontLink.href = font + "&text=" + encodeURIComponent(safeText);
        } catch (error) {
          console.warn("字體載入編碼錯誤:", error);
          // 如果編碼失敗，載入全部字體
          fontLink.href = font;
        }
        fontLink.rel = "stylesheet";
        fontLink.type = "text/css";
        fontLink.data = "font_link";
        document.head.appendChild(fontLink);
      });
    }
  }

  removeCurrentFontLink() {
    const fontLinks = document.head.querySelectorAll("link");
    fontLinks.forEach((link) => {
      this.fontList.forEach((font) => {
        link.href.indexOf(font) != -1 ? link.remove() : "";
      });
    });
  }

  checkAllFontLoaded() {
    return (
      document.head.querySelectorAll('[href="' + this.allFontLink + '"]')
        .length > 0
    );
  }

  checkIfFontLoaded() {
    // 依序檢查link的href值的開頭是否包含fontList的字串
    const fontLinks = document.head.querySelectorAll("link");
    let hasFontLoaded = false;
    this.fontList.forEach((font) => {
      let fontFound = false;
      fontLinks.forEach((link) => {
        if (link.href.indexOf(font) !== -1) {
          fontFound = true;
        }
      });
      if (fontFound) {
        hasFontLoaded = true;
      }
    });
    return hasFontLoaded;
  }

  sanitizeText(text) {
    if (!text || typeof text !== 'string') return '';
    
    // 移除 emoji 和特殊 Unicode 字符
    let sanitized = text
      // 移除常見 emoji 範圍
      .replace(/[\u{1F600}-\u{1F64F}]/gu, '') // 表情符號
      .replace(/[\u{1F300}-\u{1F5FF}]/gu, '') // 雜項符號
      .replace(/[\u{1F680}-\u{1F6FF}]/gu, '') // 交通和地圖符號
      .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '') // 區域指示符號
      .replace(/[\u{2600}-\u{26FF}]/gu, '')   // 雜項符號
      .replace(/[\u{2700}-\u{27BF}]/gu, '')   // 飾品符號
      .replace(/[\u{1F900}-\u{1F9FF}]/gu, '') // 補充符號
      // 移除控制字符（使用動態創建避免 ESLint 警告）
      // .replace(new RegExp('[\\u0000-\\u001F\\u007F-\\u009F]', 'g'), '')
      // 移除特殊字符（保留中文、英文、數字和常用標點）
      .replace(/[^\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\u30a0-\u30ff\ua-zA-Z0-9\s.,!?;:()\-_+=/*&%$#@[\]{}'"`~]/g, '')
      // 移除多餘空格
      .replace(/\s+/g, ' ')
      .trim();
      
    return sanitized;
  }

  getBodyText() {
    let str = document.body.innerText;
    let uniqueChars = "";
    for (let i = 0; i < str.length; i++) {
      if (str.charAt(i) !== " " && uniqueChars.indexOf(str.charAt(i)) === -1) {
        uniqueChars += str[i];
      }
    }
    uniqueChars = uniqueChars.replace(/\s/g, "");
    str = [...new Set(uniqueChars)].join("");

    // 使用 sanitizeText 方法來處理文本，避免重複的正則表達式
    str = this.sanitizeText(str);
    return str;
  }
}
